export default __webpack_public_path__ + "assets/community-one-two.bd39fc426ece6e63e258a14bfd454e35.png";